import "./RHookFormNumberField.css";

import { Controller, useController, useFormContext } from "react-hook-form";
import React, { FC, useEffect } from "react";

import { ITest } from "@websential/cosmic-v20";
import { InputNumber } from "primereact/inputnumber";
import { TextField } from "@mui/material";

export interface IRHookFormNumberField extends ITest {
	id: any;
	placeholder?: any;
	uppercase?: boolean;
	value?: any;
	rightAlign?: boolean;
	fieldValue?: any;
	defaultValue?: any;
	onChangeHandler: (event: any) => void;
	readOnly?: boolean;
	minFractionDigits?: number;
	maxFractionDigits?: number;
}

export const RHookFormNumberField: FC<IRHookFormNumberField> = ({
	id,
	testId,
	rightAlign = true,
	placeholder = "",
	readOnly = false,
	defaultValue,
	onChangeHandler,
	minFractionDigits = 2,
	maxFractionDigits = 2,
}) => {
	const {
		control,
		formState: { errors },
	}: any = useFormContext();

	return (
		<Controller
			name={id}
			control={control}
			defaultValue={defaultValue ?? null}
			render={({ field }) => (
				<div className="numberFieldWrapper">
					<InputNumber
						inputId={`${testId}-field`}
						value={field.value}
						onValueChange={(e) => {
							field.onChange(e.value); // ✅ RHF updated
							onChangeHandler?.(e);    // ✅ external callback
						}}

						onBlur={field.onBlur}
						placeholder={placeholder || "0.00"}
						readOnly={readOnly}
						minFractionDigits={minFractionDigits}
						maxFractionDigits={maxFractionDigits}
						inputStyle={{ textAlign: rightAlign ? "right" : "left", backgroundColor: readOnly ? "#f2f2f2" : "white", }}
						className={`numberField ${errors[id] ? "p-invalid" : ""}`}
					/>

					{errors[id] && (
						<small className="p-error">{errors[id]?.message}</small>
					)}
				</div>
			)}
		/>
	);
};
